import { useState } from "react";
import { Box, Grid, Tabs, Tab } from "@mui/material";
import Header from "../../../components/header";
import Profile from "./Profile";
import ParentWrapper from "../../../components/ParentWrapper";


function Setting() {

  return (
    // <Box
    //   sx={{
    //     ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //     p: 3
    //   }}
    // >
    <ParentWrapper>

   
      <Box
        sx={{
          display: {
            xs: "none",
            md: "initial",
          },
        }}
      >
        {/* <Header title={"My Profile"} subHeading={"Personal details and account settings"} /> */}
      </Box>
      <Grid
        container
        sx={{
          mb: 2,
          // p: 3,
          // mt: {
          //   xs: 0,
          //   md: 1,
          // },
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box sx={{}}>
            <Profile />
          </Box>
        </Box>


      </Grid>
     </ParentWrapper>
  );
}

export default Setting;



